__webpack_require__.p = "https://assets.nature.house/assets/bfb93aa1ea818cff931503aa9aba47378b066bef/build/";